import { createSlice } from '@reduxjs/toolkit';

import { vendors } from 'config/vendors';

let allVendors = vendors;
if (window.location.hostname !== "asia.games" && window.location.hostname !== "row.solutions") {
    allVendors = allVendors.filter(v => v.id !== "btg");
}

export const vendorsSlice = createSlice({
    name: 'vendors',
    initialState: {
        vendors: allVendors,
        activeVendors: {},
        allActive: true,
    },
    reducers: {
        clearVendors(state) {
            state.activeVendors = {};
            state.allActive = true;
        },
        toggleVendor(state, action) {
            if (state.activeVendors[action.payload]) {
                state.activeVendors[action.payload] = false;
            } else {
                state.activeVendors[action.payload] = true;
            }
            state.allActive = !Object.keys(state.activeVendors)
                .some(key => state.activeVendors[key])
            return state;
        },
        toggleVendorSingle(state, action) {
            if (state.activeVendors[action.payload]) {
                state.activeVendors[action.payload] = false;
            } else {
                state.activeVendors = { [action.payload]: true };
            }
            state.allActive = !Object.keys(state.activeVendors)
                .some(key => state.activeVendors[key])
            return state;
        },
    },
});

export const vendorsSelector = (state) => state.vendors;
export const { clearVendors, toggleVendor, toggleVendorSingle } = vendorsSlice.actions;
export default vendorsSlice.reducer;